<template>
    <div class="main-wrapper" v-if="loaded">
        <div class="header-section flex gap-10" :class="{'has-breadcrumbs': currentSectionId}">
            <text class="first-el" v-if="view == 'forHistory'">
                <router-link v-if="currentSectionId" to="/kyc/change-log" class="main-item">
                    Change log  
                </router-link>
                <text v-else>
                    Change log  
                </text>
            </text>
            <text v-else class="first-el">
                <router-link v-if="currentSectionId" to="/kyc/workflow/" class="main-item">
                    Workflow 
                </router-link>
                <text v-else>
                    Workflow 
                </text>
            </text>
            <img v-if="currentSectionId" src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
            <div v-if="currentSectionId" class="first-el">
                <router-link v-if="currentSectionId" :to="linkToWorkFlow" class="main-item">
                    {{ sectionName }} 
                </router-link>
            </div>

            <div class="filter-icon margin-left-auto" v-if="currentSectionId">
                <div class="button-wrap" @click="showFilter()">
                    <img src="@/assets/filter.svg" v-if="!filterActive && !showItemsChanges" class="pointer" style='pointer-events: none;'>
                    <img src="@/assets/filter-active.svg" v-else-if="filterActive && !showItemsChanges" style='pointer-events: none;' class="pointer" @click="showFilter()">
                </div>
            </div>

        </div>

        <PopupCover v-if="filterStatus" @close="filterStatus = false">
            <PopupBody
                @deleteConfirm="deleteConfirm()"
                :reviewAction="reviewAction"
                :view="view"
                @close="filterStatus = false" 
                class="setting-popup-wrapper"
            >
            <template #header>
                <div> Audit Trail</div>
            </template>
            <template #body>
                <div class="popup-body flex column gap-20">
                    <div class="flex gap-20 row w-full text-left company-name bold">
                        <div class="w-label"> Client: </div>
                        <div class="font-20"> {{ companyData ? companyData.name.value : 'N/A' }}</div>
                    </div>
                    <div class="flex row gap-20">
                        <div class="w-label text-left bold">Period:</div>
                        <div class="flex row gap-20">
                            <InpComponent
                                type="date"
                                class="input-el date-select flex-1 w-200"
                                label="Date from"
                                :key_ref="'date_from'"
                                @inputChange="filterInputChange"
                            />
                            <InpComponent
                                type="date"
                                class="input-el date-select flex-1 w-200"
                                label="Date to"
                                :key_ref="'date_to'"
                                @inputChange="filterInputChange"
                            />
                        </div>
                    </div>
                    <div class="section flex row align-start gap-20">
                        <div class="w-label text-left bold">Show details for section:</div>
                        <div class="flex column gap-5px wrap align-start">
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('section','corporate')" value="corporate">Corporate</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('section','shareholder')" value="shareholder">Shareholder</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('section','md')" value="md">Managing Director</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('section','due_diligence')" value="due_diligence">Due Diligence</div>
                            <div v-if="companyData.transaction_profile_report.value == 'YES'" class="flex align-center"><input type="checkbox" @change="setValueFilter('section','transaction_profile')" value="transaction_profile">Transaction Profile</div>
                        </div>
                    </div>

                    <div class="section flex row align-start gap-20">
                        <div class="w-label text-left bold">Type:</div>
                        <div class="flex column gap-5px wrap align-start">
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('type','workflow')" value="workflow">Workflow</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('type','changelog')" value="changelog">Change Log</div>
                        </div>
                    </div>

                    <div class="section flex row align-start gap-20">
                        <div class="w-label text-left bold">Status:</div>
                        <div class="flex column gap-5px wrap align-start">
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('status','approved')" value="workflow">Approved</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('status','pending')" value="pending">Pending</div>
                            <div class="flex align-center"><input type="checkbox" @change="setValueFilter('status','denied')" value="denied">Denied</div>
                        </div>
                    </div>
                    <div class="w-full flex row gap-10">
                        <button class="w-content transparent margin-left-auto" @click="exportReport()">Export</button>
                        <button class="w-content transparent" @click="applyFilter()">Next</button>
                    </div>
                    {{ filters }}
                </div>

            </template>
        
        </PopupBody>
        </PopupCover>

        <PopupCover v-if="dataResult && dataResult.status == 'success'" @close="dataResult = null">
            <PopupBody
                class="preview-popup"
                @close="dataResult = null">
                <template #header>
                    <div> Audit Trail Preview</div>
                </template>
                <template #body>
                    <ReportView
                        :reportData="dataResult"
                        :filters="filters"
                        @close="dataResult = null"
                    />
                </template>
            </PopupBody>
           
        </PopupCover>
        <div class="notification-view" v-if="currentSectionId">
            <div class='notification-container' v-if="loaded && confirmationNeeded.length">
                <NotificationItem 
                    v-for="notification in confirmationNeeded" 
                    :key="'notification' + notification.datetime" 
                    @click="openCase(notification)"
                    :notification="notification"
                    :view="view"
                    >
                </NotificationItem>
            </div>
            <div v-else-if="!loaded">
                Loading...
            </div>
            <div v-else>
                No items 
            </div>
            <PopupCover v-if="reviewAction" @close="close()">
                <ActionNeeded2
                    @deleteConfirm="deleteConfirm()"
                    :reviewAction="reviewAction"
                    :view="view"
                    @close="close()" 
                ></ActionNeeded2>
            </PopupCover>
        </div>
        <div v-else>
            <KycReviewItem
                :showItemsChanges="true"
                :view="view"
            />
        </div>

    </div>
    <div class='loading' v-else>
        <LoaderPopup 
            :hideHeader="true"
            :message="'Loading ...'"
        />
    </div>
 
</template>

<script setup>
import { ref, computed, onMounted, watch, defineEmits, onUnmounted } from 'vue'

const emit = defineEmits(['updatingURL'])

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime);

import ActionNeeded2 from '@/dialogs/ActionNeeded2.vue'
import PopupCover from '@/components/PopupCover.vue'
import NotificationItem from '@/components/NotificationItem.vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import store from '../store';
import LoaderPopup from '@/components/LoaderPopup.vue'
import API from '../api/index.js'
import KycReviewItem from './KycReviewItem.vue';
import InpComponent from '@/components/InpComponent.vue';
import PopupBody from '@/components/PopupBody.vue';
import ReportView from '@/components/ReportView.vue';


const router = useRouter()
const route = useRoute()


const props = defineProps(['view', 'id', 'item_id'])
const reviewAction = ref(null);
const loaded = ref(false);

const showItemsChanges = ref(false);
const filterStatus = ref(false);
const filters = ref({})




const notifications = ref([])
const notificationsCountTotal = ref(null);
const currentPage = ref(1);
const notificationId = ref(props.item_id);
let currentSectionId = ref(null)

const dataResult = ref(null);

const companyData = computed(() => store.state.companyData);
const filterActive = computed(() => Object.keys(filters.value).length > 0)
const confirmationNeeded = computed(() => store.state.confirmationNeeded);
const linkToWorkFlow = computed( () => ({name: 'client-item', params: {id: currentSectionId.value}}) )

const KYC_Available = computed(() => store.getters.KYC_Available)

const sectionName = computed(() => {
    if (!companyData.value) {
        return 'N/A';
    }
    if (companyData.value.company_type == 'corporate') {
        return companyData.value.name.value + ' Corporate';
    } 
    return companyData.value.first_name.value + " " + companyData.value.last_name.value + ' Account Holder';
})



async function loadData() {
    if (!currentSectionId.value) {
        loaded.value = true;
        return
    }
    if (!companyData.value) {
        await API.loadDashboardData({company_id: currentSectionId.value});
    }
    loaded.value = false;

    const response = await API.getNotificationList({page:currentPage.value, view: props.view, id: currentSectionId.value});
    if (props.view == 'forConfirmation' && currentSectionId.value) {
        store.state.proposedChanges = response.notifications;
        await API.getNotificationCount({view: props.view, id: currentSectionId.value});

        document.title = 'Changes waiting for confirmation';
    } else {
        document.title = 'History of changes';
    }

    store.state.confirmationNeeded = response.notifications;
    notifications.value = response.notifications;
    notificationsCountTotal.value = response.count;
    loaded.value = true;

}

async function init() {
    console.log('AR_mounted!!!!!!!!!!!')
    if (props.id) {
        currentSectionId.value = props.id;
        await loadData();
    } else {
        loaded.value = true;
    }
    if (props.item_id) {
       await renderNotification();
    }
} 


function validate(){
    if (!filters.value.date_from || !filters.value.date_to) {
        store.dispatch('addNotification', {text: 'Please fill in information for the "Period"', type: 'error'})
        return false
    }
    if (!filters.value.section || filters.value.section.length === 0) {
        store.dispatch('addNotification', {text: 'Please select at least one option for "Section"', type: 'error'})
        return false
    }
    if (!filters.value.type || filters.value.type.length === 0) {
        store.dispatch('addNotification', {text: 'Please select at least one option for "Type"', type: 'error'})
        return false
    }
    if (!filters.value.status || filters.value.status.length === 0) {
        store.dispatch('addNotification', {text: 'Please select at least one option for "Status"', type: 'error'})
        return false
    }
    return true;
}

async function exportReport(){
    let result = validate();
    if (!result) {
        return;
    }
    const APIResult = await API.exportReport({
        filters: filters.value,
        companyDataId: companyData.value._id,
    });

    dataResult.value = APIResult;


}



async function deleteConfirm() {
    
    await loadData();
    const viewMap = {
        'forConfirmation': 'workflow-item',
        'forHistory': 'change-log-item'
    }
    router.push({name: viewMap[props.view], params: {id: currentSectionId.value}});
    reviewAction.value = null;
}

function close() {
    console.log('close')
    const viewMap = {
        'forConfirmation': 'workflow-item',
        'forHistory': 'change-log-item'
    }
    console.log('viewMap', viewMap[props.view])
    router.push({name: viewMap[props.view], params: {id: currentSectionId.value}});
    reviewAction.value = null;
}

function openCase(notification) {
    const viewMap = {
        'forConfirmation': 'workflow-item-inner',
        'forHistory': 'change-log-item-inner'
    }
    console.log('a', props.view, notification, viewMap[props.view]);
    router.push({name: viewMap[props.view], params: { id: currentSectionId.value, item_id: notification._id}});
}

async function renderNotification() {
    const result = await API.loadNotification(notificationId.value);
    
    reviewAction.value = result.notification;
}


const showFilter = () => { 
    filterStatus.value = !filterStatus.value 

    filters.value = { 
        "date_from": "2025-07-01", 
        "date_to": "2025-11-23", 
        "section": [ "corporate", "shareholder", "md", "due_diligence", "transaction_profile" ], 
        "type": [ "workflow" ], 
        "status": [ "pending" ] 
    }
}


function clearFilter() {
    filters.value = {};
    filterStatus.value = false;
    doRequest();
}
function filterInputChange(event){
    filters.value[event[0]] = event[1];
    if (!event[1]) {
        delete filters.value[event[0]];
    }
}
async function applyFilter(){
    await doRequest();
    filterStatus.value = false;
}


function setValueFilter(type, value) {
    if (!filters.value[type]) {
        filters.value[type] = [];
    }
    const index = filters.value[type].indexOf(value);
    if (index > -1) {
        filters.value[type].splice(index, 1);
    } else {
        filters.value[type].push(value);
    }
}


onMounted(async() => {
    await init();
});

onBeforeRouteLeave((to, from, next) => {
    if (!KYC_Available.value){
        next();
        return;
    }
    if (!companyData.value ||
        !to.path.includes(companyData.value._id) 
    ) {
        loaded.value = false;
        store.dispatch('setValue', { key: 'companyData', value: null })
        store.dispatch('setValue', { key: 'confirmationNeeded', value: null })
        store.dispatch('setValue', { key: 'notificationsCount', value: null })
    }
    next(); // Proceed with navigation
});








watch(() => props.id, async (newVal, oldVal) => {
    if (oldVal){
        await init();
    }
});

watch(() => props.view, async (newVal, oldVal) => {
    if (oldVal){
        await loadData();
    }
});
watch(() => props.item_id, (newVal) => {
    notificationId.value = newVal;
    if (notificationId.value) {
        renderNotification();
    }
})
watch(() => props.id, (newVal) => {
    currentSectionId.value = newVal;
    if (newVal) {
        loaded.value = false;
        loadData();
    } else {
        store.dispatch('setValue', { key: 'notificationsCount', value: null })
    }
})
</script>


<style scoped lang="scss">
.main-wrapper {
    max-width: 1350px;
    padding: 20px;
    margin: auto;
}
.has-breadcrumbs {
    display: flex;
    align-items: center;
    font-size: 16px;
    .first-el > a {
        font-size: 16px;
        color: var(--primary-color);
        text-decoration: none;
    }
}
.notification-view {
    border-radius: 10px;
    border: 1px solid var(--border-color);
    background-color: white;
    margin: auto;
    padding: 20px;
}
.notification-item {
    border-bottom: 1px solid var(--border-color);
    padding: 20px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
}
.notification-container {
    border-radius: 10px;
    border: 1px solid var(--border-color);
    background-color: white; 
    max-height: 77vh;
    overflow-y: auto;
}
.user-name {
    font-weight: bold;
    color: #595b61;
}
.notification-time {
    color: #74777F;
    font-size: 12px;
    display: flex;
    gap: 5px;
}
.notification-message {
    text-align: left;
    color: #181C22;
    font-size: 16px;
}
.notiifcation-info-conteiner {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
}
.time-relative {
    width: 100px;
    padding-right: 0;
}
.table-users {
    width: 100%;
    border-collapse: collapse;
    border-bottom: 1px solid #e6eaed;
}
.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
.is-read-false {
    background: #f9f9f9;
}
td {
    padding: 10px 30px;
    text-align: left;
}
th {
    text-align: left;
    padding: 10px 30px;
    background: #E6EAED;
}
.preview {
    padding: 10px;
    cursor: pointer;
    width: 30px;
}

.icon {
    background-color: gray;
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(224 226 236);
    position: relative;
    &.is-read-false {
        &::after {
            content: '';
            position: absolute;
            right: 10px;
            top: 10px;
            left: -15px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: rgb(224 226 236);
    
        }

    }
}
.change-item {
    padding: 2px 12px;
    background-color: var(--primary-color);
    color: white;
    border-radius: 3px;
    width: fit-content;
}
.pagination {
    display: flex;
    gap: 10px;

  &:deep(li) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

  }
  &:deep(.paginate-buttons) {
    height: 40px;

    width: 40px;
   
    border-radius: 20px;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    color: black;
  }

  &:deep(.paginate-buttons:hover) {
    background-color: #d8d8d8;
  }

  &:deep(.active-page) {
    background-color: var(--primary-color);

    border: 1px solid var(--primary-color);

    color: white;
  }

  &:deep(.active-page:hover) {
    background-color: var(--primary-color);
  }
}

.notificaiton-read {
    width: 100%;
    text-align: right;
    cursor: pointer;
    text-decoration: underline;
}


.cover-elem {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    width: 100%;
    height: 100%;
} 
.filter-area {
    padding: 15px 30px;
    box-sizing: border-box;
    position: relative;
    // top: 60px;
    // left: 1px;
    // right: 1px;
    min-height: 180px;
    height: fit-content;
    background-color: white;
    z-index: 10000;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border: 1px solid #ccc;
    max-width: 1310px;
    margin:auto;
    margin-bottom: 20px;

}
.subsidiary-title {
    display: flex;
    justify-content: space-between;
    color: black;
    font-size: 20px;
}
.cross {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
}
.button-wrap {
    border: 1px solid var(--border-color);
    border-radius: 5px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    cursor: pointer;

    &:hover {
        background-color: rgb(250, 250, 250);
    }
}
h4 {
    margin: 0;
}
.filters-list {
    padding-top: 20px;

    .input-el {
        margin-bottom: 0;
    }
}

.preview-popup[class] {
    width: 1300px;
    max-width: 100%;
    height: fit-content;
    min-height: 300px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 90vw;
}

.setting-popup-wrapper[class] {
    width: 600px;
    max-width: 100%;
    height: fit-content;
    min-height: 300px;
    padding: 20px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}


.w-label {
    width: 150px;
}
.popup-body {
    :deep(.input-el) {
        margin-bottom: 0px;
    }
}
.header-section[class] {
    padding-top: 0;
}
</style>